var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.anonymousCrossOrigin)?_c('image',{attrs:{"width":"800","height":"1000","xlink:href":_vm.shadowLink}}):_c('img',{attrs:{"crossorigin":"anonymous","src":_vm.shadowLink}})}
var staticRenderFns = []

export { render, staticRenderFns }